import { render, staticRenderFns } from "./DiffractionGratingViz.vue?vue&type=template&id=4448efe5&scoped=true"
import script from "./DiffractionGratingViz.vue?vue&type=script&lang=js"
export * from "./DiffractionGratingViz.vue?vue&type=script&lang=js"
import style0 from "./DiffractionGratingViz.vue?vue&type=style&index=0&id=4448efe5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448efe5",
  null
  
)

export default component.exports